import React, { Component } from 'react';
import { Hero } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 * @prop {Object} [forwardedRef]
 *
 * @augments {Component<Props>}
 */
class HeroView extends Component {

	render () {
		const {
			buttonLabel,
			emailAddress,
			heading,
			href,
			phoneNumber,
			startsCount,
			subheading,
		} = this.props.content.landingPage.hero;

		return (
			<Hero
				{...{
					buttonLabel,
					emailAddress,
					heading,
					href,
					phoneNumber,
					startsCount,
					subheading,
				}}
				className='HeroView'
				forwardedRef={this.props.forwardedRef}
			/>
		);
	}

}

export default withLanguageContext(HeroView);



// WEBPACK FOOTER //
// ./src/components/views/HeroView/HeroView.js